import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { IgxGridModule, IgxProgressBarModule, IgxToggleModule } from "@infragistics/igniteui-angular";
import { WaitIndicatorComponent } from "./wait-indicator/wait-indicator.component";

@NgModule({
    declarations: [
        WaitIndicatorComponent,
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        IgxGridModule,
        IgxProgressBarModule,
        IgxToggleModule,
    ],
    exports: [
        WaitIndicatorComponent,
    ],
    providers: []
})
export class SharedModule { }